import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../../api";
import { FiChevronDown, FiHelpCircle, FiArrowLeft } from "react-icons/fi";

const FAQSection = () => {
  const [faqs, setFaqs] = useState([]);
  const [openIndex, setOpenIndex] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    const fetchFaqs = async () => {
      try {
        setLoading(true);
        setError(false);

        // فقط 5 سوال اول برای صفحه اصلی
        const response = await api.get("/home/faq/?limit=5");

        setFaqs(response.data);
      } catch (err) {
        console.error("خطا در دریافت سوالات متداول:", err);
        setError(true);
      } finally {
        setLoading(false);
      }
    };

    fetchFaqs();
  }, []);

  const toggleAccordion = (index) => {
    setOpenIndex((previousIndex) =>
      previousIndex === index ? null : index
    );
  };

  return (
    <section className="mx-auto max-w-4xl" dir="rtl">
      <div className="overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-sm">
        <div className="border-b border-gray-100 px-4 py-5 text-center sm:px-5">
          <div className="mx-auto flex h-11 w-11 items-center justify-center rounded-full bg-[#1E3A5F]/10 text-[#1E3A5F]">
            <FiHelpCircle className="h-6 w-6" />
          </div>

          <h2 className="mt-3 text-lg font-semibold text-gray-900 md:text-xl">
            سوالات متداول
          </h2>

          <p className="mt-2 text-sm text-gray-500 md:text-base">
            پاسخ سوالات پرتکرار خود را اینجا بیابید
          </p>
        </div>

        <div className="px-4 py-4 sm:px-5 sm:py-5">
          {loading && (
            <div className="space-y-3">
              {[...Array(5)].map((_, index) => (
                <div
                  key={index}
                  className="h-16 animate-pulse rounded-2xl border border-gray-200 bg-gray-50"
                />
              ))}
            </div>
          )}

          {!loading && error && (
            <div className="rounded-2xl border border-gray-200 bg-white py-10 text-center">
              <p className="text-sm text-gray-500">
                در دریافت سوالات متداول مشکلی پیش آمد. لطفاً بعداً دوباره تلاش
                کنید.
              </p>
            </div>
          )}

          {!loading && !error && faqs.length === 0 && (
            <div className="rounded-2xl border border-gray-200 bg-white py-10 text-center">
              <p className="text-sm text-gray-500">
                در حال حاضر سوالی ثبت نشده است.
              </p>
            </div>
          )}

          {!loading && !error && faqs.length > 0 && (
            <>
              <div className="space-y-3">
                {faqs.map((faq, index) => {
                  const isOpen = openIndex === index;

                  return (
                    <div
                      key={faq.id}
                      className={`overflow-hidden rounded-2xl border bg-white shadow-sm transition-colors duration-200 ${
                        isOpen ? "border-[#1E3A5F]/30" : "border-gray-200"
                      }`}
                    >
                      <button
                        type="button"
                        onClick={() => toggleAccordion(index)}
                        aria-expanded={isOpen}
                        aria-controls={`home-faq-answer-${faq.id}`}
                        className="flex w-full items-center justify-between gap-3 p-4 text-right transition-colors hover:bg-gray-50 focus:outline-none sm:p-5"
                      >
                        <span
                          className={`min-w-0 flex-1 text-sm font-medium md:text-base ${
                            isOpen ? "text-gray-900" : "text-gray-700"
                          }`}
                        >
                          {faq.question}
                        </span>

                        <span
                          className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition-colors duration-200 ${
                            isOpen
                              ? "bg-[#1E3A5F] text-[#FFC107]"
                              : "bg-gray-100 text-gray-500"
                          }`}
                        >
                          <FiChevronDown
                            className={`h-4 w-4 transition-transform duration-300 ${
                              isOpen ? "rotate-180" : ""
                            }`}
                          />
                        </span>
                      </button>

                      <div
                        id={`home-faq-answer-${faq.id}`}
                        className={`grid overflow-hidden transition-all duration-300 ease-in-out ${
                          isOpen
                            ? "grid-rows-[1fr] border-t border-gray-100"
                            : "grid-rows-[0fr]"
                        }`}
                      >
                        <div className="overflow-hidden">
                          <div className="bg-gray-50/70 p-4 text-sm leading-8 text-gray-600 md:p-5 md:text-base">
                            {faq.answer}
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>

              <div className="mt-6 flex justify-center">
                <Link
                  to="/faq"
                  className="inline-flex items-center gap-2 rounded-xl bg-[#1E3A5F] px-5 py-3 text-sm font-medium text-white transition-colors hover:bg-[#162d4a] focus:outline-none focus:ring-2 focus:ring-[#1E3A5F] focus:ring-offset-2"
                >
                  مشاهده همه سوالات
                  <FiArrowLeft className="h-4 w-4" />
                </Link>
              </div>
            </>
          )}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
